import { render, staticRenderFns } from "./innerBranches.vue?vue&type=template&id=172a6248&scoped=true"
import script from "./innerBranches.vue?vue&type=script&lang=js"
export * from "./innerBranches.vue?vue&type=script&lang=js"
import style0 from "./innerBranches.vue?vue&type=style&index=0&id=172a6248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172a6248",
  null
  
)

export default component.exports